export const isTicketingGenerateReceipt = (
  rates: { isGeneratingReceipt: boolean }[] | undefined,
  extraDonation: boolean,
  generateExtraDonationReceipt: boolean | undefined,
  organizationCanGenerateReceipt: boolean
) => {
  if (!organizationCanGenerateReceipt) {
    return false;
  }
  const ticketsWithGenerateReceiptChecked = rates?.filter((rate) => rate.isGeneratingReceipt);
  const ticketingGenerateReceipt = ticketsWithGenerateReceiptChecked && ticketsWithGenerateReceiptChecked.length > 0;

  const generateReceiptOnExtraDonation = extraDonation && generateExtraDonationReceipt;

  return ticketingGenerateReceipt || generateReceiptOnExtraDonation;
};
